<script lang="ts">
  import DynamicBlock from './dynamic-block.svelte';
  import type { AbTestContentStoryblok } from '$types/bloks';
  import { abTestVersion } from '$lib/stores/ab-test-version';

  export let block: AbTestContentStoryblok;
</script>

{#if block.version === $abTestVersion && block.body}
  {#each block.body as b}
    <DynamicBlock block={b} />
  {/each}
{/if}
